import { useLanguage } from "@/i18n";
import Reveal, { MaskedLines } from "@/components/Reveal";

const LegalPage = ({ kind }) => {
  const { t } = useLanguage();
  const content = kind === "legal" ? t.legal : t.privacy;

  return (
    <main data-testid={`${kind}-page`} className="min-h-screen bg-[#070A10] px-4 pb-24 pt-32 sm:px-6">
      <div className="mx-auto max-w-3xl">
        <MaskedLines baseDelay={0.1} lines={[t.common.brand + " SA — Genève"]} lineClassName="font-mono text-xs uppercase tracking-[0.3em] text-cyan-400" />
        <MaskedLines
          baseDelay={0.25}
          lines={[content.title]}
          className="mt-4"
          lineClassName="text-3xl font-extrabold uppercase tracking-tight text-white sm:text-5xl"
        />
        <Reveal delay={0.45}>
          <p className="mt-5 font-mono text-xs uppercase tracking-[0.2em] text-slate-500" data-testid={`${kind}-updated`}>
            {content.updated}
          </p>
        </Reveal>

        <div className="mt-12 space-y-8">
          {content.sections.map((s, i) => (
            <Reveal key={s.h} delay={i * 0.05}>
              <section className="rounded-2xl border border-white/10 bg-[#0A0D14] p-6 sm:p-8">
                <h2 className="text-lg font-bold text-white sm:text-xl" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
                  {s.h}
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">{s.p}</p>
              </section>
            </Reveal>
          ))}
        </div>
      </div>
    </main>
  );
};

export default LegalPage;
